import { Row, Col, Panel, Content, Navbar, DateRangePicker, IconButton, InputGroup, Button, Input } from "rsuite"
import SettingIcon from '@rsuite/icons/Setting';
import { useEffect, useState } from "react";
import SearchIcon from '@rsuite/icons/Search';

import PanelHeader from "../panels/panelHeader";
import BriefCreateDrawer from "./briefCreateDrawer";

import { startNewEdit } from "./briefLocalStorageManager";

export default function BriefHeader({open, setOpen}) {
    return (
        <PanelHeader justify="end">
            <span className="panel-with-data-header-options">
                <InputGroup>
                    <Input  placeholder="Поиск"/>
                    <InputGroup.Addon>
                        <SearchIcon />
                    </InputGroup.Addon>
                </InputGroup>
            </span>
            <Button appearance="primary" color="green" onClick={() => {
                startNewEdit();
                setOpen(true);
            }}>Создать бриф</Button>
        </PanelHeader>
    )
}